import { render, staticRenderFns } from "./Transhipment.vue?vue&type=template&id=cb879e30"
import script from "./Transhipment.vue?vue&type=script&lang=js"
export * from "./Transhipment.vue?vue&type=script&lang=js"
import style0 from "./Transhipment.vue?vue&type=style&index=0&id=cb879e30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports